'use client';

import { useTranslations } from 'next-intl';

import type { EmploymentStatusStep } from '@/modules/authentication/view-model';

import { EmploymentStatusEnum } from '@packages/contracts';
import { Form } from '@packages/hook-form-wrapper';

export const EmploymentStatus = () => {
	const t = useTranslations('authentication.registration.form.employmentStatus');

	const options = EmploymentStatusEnum.options.map(value => ({
		label: t('enum', { employmentStatus: value }),
		value,
	}));

	return (
		<Form.RadioGroup<EmploymentStatusStep> gap={8} name="employmentStatus" options={options} />
	);
};
